import moment from 'moment'
import { MINUTES_IN_DAY } from '../tabs/support/components/InteractionTimer/config'

export const getMinutesLeft = start => {
  const now = moment.now()
  const utcDate = moment(start).utc(true)

  return MINUTES_IN_DAY - moment(now).diff(utcDate, 'minutes')
}
